export const testimonials = [
  {
    id: 1,
    name: "Balsa",
    rating: 5,
    comment: "Les coupes sont vraiment excellentes, les prix sont très abordables, et l'endroit est impeccablement propre. En plus, tu peux même profiter d'une boisson gratuite pendant que tu attends ou pendant ta coupe ! L'ambiance est agréable.",
    date: "Il y a 3 semaines",
    dateEn: "3 weeks ago",
    avatar: "https://ui-avatars.com/api/?name=Balsa&background=00D9FF&color=fff"
  },
  {
    id: 2,
    name: "big draco",
    rating: 5,
    comment: "Il n'y a pas une meilleure place pour aller se faire couper les cheveux à Montréal. Les coupes dépassent toujours mes attentes et les barbers eux même sont gentils, chaleureux et super sympathiques.",
    date: "Il y a 4 mois",
    dateEn: "4 months ago",
    avatar: "https://ui-avatars.com/api/?name=Big+Draco&background=FF1493&color=fff"
  },
  {
    id: 3,
    name: "Yussouf Ndoye",
    rating: 5,
    comment: "Je vous recommande vivement DNA Barbershop! L'ambiance est détendue, les prix sont très honnêtes pour la qualité du service 💯💯💯💯",
    date: "Il y a 1 semaine",
    dateEn: "1 week ago",
    avatar: "https://ui-avatars.com/api/?name=Yussouf+Ndoye&background=5B7FFF&color=fff"
  },
  {
    id: 4,
    name: "Elia Bouaziz",
    rating: 5,
    comment: "Le service est exceptionnel et l'ambiance est très conviviale. Les barbers savent ce qu'ils font jamais jme suis fais charcuter ici 💯💯",
    date: "Il y a 3 semaines",
    dateEn: "3 weeks ago",
    avatar: "https://ui-avatars.com/api/?name=Elia+Bouaziz&background=00D9FF&color=fff"
  },
  {
    id: 5,
    name: "Steph Sam",
    rating: 5,
    comment: "Très professionnel et un salon de coiffure avec billard et console de jeux pour patienter. Je reviens avec mon fils tout le temps.",
    date: "Il y a 4 mois",
    dateEn: "4 months ago",
    avatar: "https://ui-avatars.com/api/?name=Steph+Sam&background=FF1493&color=fff"
  },
  {
    id: 6,
    name: "Fares Boualbani",
    rating: 5,
    comment: "Très bon barber, très bonne ambiance et très bonne clientèle. Je vous le conseille fortement.",
    date: "Il y a 4 semaines",
    dateEn: "4 weeks ago",
    avatar: "https://ui-avatars.com/api/?name=Fares+Boualbani&background=5B7FFF&color=fff"
  },
  {
    id: 7,
    name: "Ibrahima Dieng",
    rating: 5,
    comment: "Coupe parfaite. J'adore le service j'aime trop meziane 😍😍",
    date: "Il y a 3 semaines",
    dateEn: "3 weeks ago",
    avatar: "https://ui-avatars.com/api/?name=Ibrahima+Dieng&background=00D9FF&color=fff"
  },
  {
    id: 8,
    name: "Younes Bouallou",
    rating: 5,
    comment: "Très bel accueil, boisson illimités pour les clients ça fait vraiment plaisir.",
    date: "Il y a 3 semaines",
    dateEn: "3 weeks ago",
    avatar: "https://ui-avatars.com/api/?name=Younes+Bouallou&background=FF1493&color=fff"
  }
];

export const barbers = [
  {
    id: 1,
    name: "Amine Twinz",
    specialty: "Spécialiste Coupes Enfants",
    specialtyEn: "Kids Haircut Specialist",
    role: "Spécialisé dans les coupes enfants, Amine allie patience, précision et style pour des résultats nets et modernes.",
    roleEn: "Specializing in kids haircuts, Amine combines patience, precision and style for clean, modern results.",
    image: "https://customer-assets.emergentagent.com/job_ef2d7337-2c3d-4774-b000-032819c37cf2/artifacts/4ixjla37_IMG_1299.jpeg",
    experience: "6+ ans",
    experienceEn: "6+ years"
  },
  {
    id: 2,
    name: "Meziane Twinz",
    specialty: "Expert Dégradés & Finitions",
    specialtyEn: "Fade & Finishing Expert",
    role: "Expert en coupes enfants et adultes, Meziane est reconnu pour ses dégradés propres et ses finitions impeccables.",
    roleEn: "Expert in kids and adult haircuts, Meziane is known for his clean fades and flawless finishing touches.",
    image: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/uh8gbr1c_IMG_3835.JPG",
    experience: "6+ ans",
    experienceEn: "6+ years"
  },
  {
    id: 3,
    name: "Omar Oz",
    specialty: "Master Barber & Précision",
    specialtyEn: "Master Barber & Precision",
    role: "Master barber passionné, Omar excelle dans les coupes classiques et modernes avec une attention particulière aux détails.",
    roleEn: "A passionate master barber, Omar excels in classic and modern cuts with particular attention to detail.",
    image: "https://customer-assets.emergentagent.com/job_ef2d7337-2c3d-4774-b000-032819c37cf2/artifacts/511ls1eu_6062.jpeg",
    experience: "3+ ans",
    experienceEn: "3+ years"
  },
  {
    id: 4,
    name: "Alassane",
    specialty: "Barbier Talentueux",
    specialtyEn: "Talented Barber",
    role: "Nouveau talent prometteur, Alassane apporte énergie et créativité à chaque coupe avec un sens du détail remarquable.",
    roleEn: "A promising new talent, Alassane brings energy and creativity to every cut with remarkable attention to detail.",
    image: "https://customer-assets.emergentagent.com/job_ef2d7337-2c3d-4774-b000-032819c37cf2/artifacts/lnpkm3j0_C0C555DB-3DCD-4FA8-A91B-0D709B4C42EE.jpeg",
    experience: "1+ an",
    experienceEn: "1+ year"
  },
  {
    id: 5,
    name: "Mohamed.A",
    specialty: "Barbier Créatif & Polyvalent",
    specialtyEn: "Creative & Versatile Barber",
    role: "Barbier créatif et polyvalent, Mohamed allie technique et style pour des coupes qui reflètent la personnalité de chaque client.",
    roleEn: "A creative and versatile barber, Mohamed combines technique and style for cuts that reflect each client's personality.",
    image: "https://customer-assets.emergentagent.com/job_ef2d7337-2c3d-4774-b000-032819c37cf2/artifacts/b3bs1apw_IMG_6780.jpeg",
    experience: "2+ ans",
    experienceEn: "2+ years"
  }
];

export const services = [
  {
    id: 1,
    name: "Taper+Beard+Scissors",
    price: 40,
    duration: "45 min",
    description: "Coupe taper complète avec barbe et finitions aux ciseaux",
    descriptionEn: "Full taper cut with beard and scissor finishing",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/3c5iycce_High_Taper_with_Beard_1_1200x.webp"
  },
  {
    id: 2,
    name: "Fade+Beard+Scissors",
    price: 40,
    duration: "45 min",
    description: "Fade complet avec barbe et finitions aux ciseaux",
    descriptionEn: "Full fade with beard and scissor finishing",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/xtfuf11b_beard-fade-haircuts-696x696.webp"
  },
  {
    id: 3,
    name: "Taper+Beard",
    price: 35,
    duration: "45 min",
    description: "Coupe taper élégante avec taille de barbe professionnelle",
    descriptionEn: "Elegant taper cut with professional beard trim",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/3c5iycce_High_Taper_with_Beard_1_1200x.webp"
  },
  {
    id: 4,
    name: "Fade + Beard",
    price: 35,
    duration: "45 min",
    description: "Fade précis avec entretien complet de la barbe",
    descriptionEn: "Precise fade with full beard maintenance",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/xtfuf11b_beard-fade-haircuts-696x696.webp"
  },
  {
    id: 5,
    name: "Taper",
    price: 30,
    duration: "30 min",
    description: "Coupe taper moderne et stylée",
    descriptionEn: "Modern and stylish taper cut",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/vw5v14v5_Afro-Taper.webp"
  },
  {
    id: 6,
    name: "Fade",
    price: 30,
    duration: "30 min",
    description: "Coupe fade classique et précise",
    descriptionEn: "Classic and precise fade cut",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/9rlpn542_maxresdefault.jpg"
  },
  {
    id: 7,
    name: "Mèches caramel",
    nameEn: "Caramel Highlights",
    price: 75,
    duration: "35 min",
    description: "Coloration mèches caramel professionnelle",
    descriptionEn: "Professional caramel highlights coloring",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/pjimzajd_320f712c2abca267af6cecd8345f1177.jpg"
  },
  {
    id: 8,
    name: "Kids Haircut",
    price: 25,
    duration: "30 min",
    description: "Coupe pour enfants dans une ambiance décontractée",
    descriptionEn: "Kids haircut in a relaxed atmosphere",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/128e2yva_SMS-5033_BlogImage_Jun_1080x1080.jpg"
  },
  {
    id: 9,
    name: "Lineup",
    price: 20,
    duration: "15 min",
    description: "Contours et finitions impeccables",
    descriptionEn: "Flawless outline and finishing touches",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/xtfuf11b_beard-fade-haircuts-696x696.webp"
  },
  {
    id: 10,
    name: "Blackmask",
    price: 12,
    duration: "15 min",
    description: "Soin du visage avec masque noir purifiant",
    descriptionEn: "Facial care with purifying black mask",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/fiqab4ov_img_6295.webp"
  },
  {
    id: 11,
    name: "Beard/Scissors/Design",
    price: 10,
    duration: "15 min",
    description: "Taille de barbe, ciseaux et designs personnalisés",
    descriptionEn: "Beard trim, scissors and custom designs",
    image: "https://customer-assets.emergentagent.com/job_snip-style-27/artifacts/w217c9lw_f643900d0de82e6ad772c4899d084d5a.jpg"
  }
];

export const gallery = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/3iboa5z1_IMG_5377.png",
    alt: "Espace détente avec table de billard"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/1tsov4e0_IMG_5379.png",
    alt: "Mid fade"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/epgslnll_IMG_5380.png",
    alt: "Fade avec design"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/wfvi3tnr_IMG_5378.png",
    alt: "High taper"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/sbf3px5n_96AE44C0-BE37-4679-9E4B-32FF89E5E0B6.JPG",
    alt: "Intérieur DNA Barbershop"
  }
];

export const businessInfo = {
  name: "DNA BARBERSHOP",
  logo: "https://customer-assets.emergentagent.com/job_coif-expert-8/artifacts/p7qm6iux_IMG_4013.png",
  phone: "(438) 922-1776",
  email: "dna.thebarber@gmail.com",
  address: "2911 Rue Allard, Montréal, QC H4E 2M4",
  bookingUrl: "https://dna-barbershop.square.site/",
  hours: [
    { day: "Lundi", dayEn: "Monday", hours: "Fermé", hoursEn: "Closed", open: false },
    { day: "Mardi", dayEn: "Tuesday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true },
    { day: "Mercredi", dayEn: "Wednesday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true },
    { day: "Jeudi", dayEn: "Thursday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true },
    { day: "Vendredi", dayEn: "Friday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true },
    { day: "Samedi", dayEn: "Saturday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true },
    { day: "Dimanche", dayEn: "Sunday", hours: "10h00 - 19h00", hoursEn: "10:00 AM - 7:00 PM", open: true }
  ],
  googleMapsUrl: "https://www.google.com/maps/dir/?api=1&destination=2911+Rue+Allard+Montr%C3%A9al+QC+H4E+2M4"
};
